import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PokerGameModel } from 'mvppoker-portal-common/api'

export interface PublicUser {
	userId: string,
	rooms: PokerGameModel[],
	activeGame?: PokerGameModel
}

const initialState: PublicUser = {
	userId: `public-${Date.now()}`,
	rooms: []
}

export const publicUserSlice = createSlice({
	name: 'PublicUser',
	initialState,
	reducers: {
		updatePublicRooms: (state, action: PayloadAction<PokerGameModel[]>) =>{
			state.rooms = action.payload
		},
		makePublicActiveGame: (state, action: PayloadAction<PokerGameModel | undefined>) => {
			state.activeGame = action.payload
		},
		updatePublicActiveGame: (state, action: PayloadAction<PokerGameModel>) => {
			state.activeGame = action.payload
		},
		clearPublicActiveGame: (state) => {
			state.activeGame = undefined
		},
	},
})

export const { updatePublicRooms, makePublicActiveGame, updatePublicActiveGame, clearPublicActiveGame } = publicUserSlice.actions

export default publicUserSlice.reducer